import React from 'react'

import {
  Box,
  Color,
  DisplayPosition,
  FontWeight,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import type { StandardRecipeItem } from '@library/api-menu-experience'

type CustomisationLabelProps = {
  recipe: StandardRecipeItem
  isOpen?: boolean
  onClick?: () => void
}

const CustomisationButton = withCitrusTheme('button', () => ({
  appearance: 'none',
  background: 'transparent',
  border: 0,
  color: 'inherit',
  cursor: 'pointer',
  font: 'inherit',
  margin: 0,
  padding: 0,
  '&:focus-visible': {
    outline: '2px solid #615CFF',
    outlineOffset: '2px',
  },
}))

export const CustomisationLabel = ({
  recipe,
  isOpen = false,
  onClick,
}: CustomisationLabelProps) => {
  const label = recipe.customisations?.label
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    onClick?.()
  }

  if (!label) {
    return null
  }

  return (
    <Box
      position={DisplayPosition.Relative}
      style={{
        zIndex: 30,
      }}
    >
      {onClick ? (
        <CustomisationButton
          type="button"
          aria-expanded={isOpen}
          aria-label={`${label} ${recipe.title}`}
          onClick={handleClick}
          data-testid="recipe-tile-customise-button"
        >
          <Text color={Color.Secondary_400} fontWeight={FontWeight.Bold}>
            {label}
          </Text>
        </CustomisationButton>
      ) : (
        <Text color={Color.Secondary_400} fontWeight={FontWeight.Bold}>
          {label}
        </Text>
      )}
    </Box>
  )
}
